/* Publish by EComposer at 2026-10-14 13:48:44*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-15gb0ervvf4"]=  window.__ectimmers["ecom-15gb0ervvf4"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),s=t.querySelector(".text-content.ecom-html");!s||(e&&e.addEventListener("click",()=>{s.classList.remove("ecom-text--is-mark"),s.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{s.classList.add("ecom-text--is-mark"),s.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-15gb0ervvf4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-15gb0ervvf4', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rsq3g6yinio').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rsq3g6yinio', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pgzpdbcwm3l').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pgzpdbcwm3l', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4p04jzxj0xw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4p04jzxj0xw', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qbe04o0ln1').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qbe04o0ln1', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7rn8mp464ni').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7rn8mp464ni', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-ipdjskrq0mj"]=  window.__ectimmers["ecom-ipdjskrq0mj"] || {};
if(!this.$el)return!1;const t=this.$el;this.settings.animation&&function(i){if(!t)return;const s=t.querySelector(".ecom__element--button");if(!s)return;let o=parseInt(i.settings.animation_loop_time)*1e3||6e3,n=1e3;window.__ectimmers["ecom-ipdjskrq0mj"]["or7tk1u5u"] = setInterval(function(){s.classList.add("animated"),setTimeout(function(){s.classList.remove("animated")},n)},o)}(this);var e=t.querySelector(".ecom__element--button");this.isLive&&e&&e.dataset.ecTrackingId&&e.addEventListener("click",function(i){if(window.Shopify&&window.Shopify.analytics){i.preventDefault();let s=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const o=Object.assign({button_id:e.id,tracking_id:e.dataset.ecTrackingId},s);try{Shopify.analytics.publish("ec_custom_events",o)}catch(a){console.error("[EC Tracking] Error publishing analytics event:",a)}const n=e.getAttribute("href"),r=e.getAttribute("target");n&&n!=="#"&&n!=="javascript:void(0)"&&(r==="_blank"?window.open(n,"_blank"):setTimeout(function(){window.location.href=n},300))}},{once:!0}),this.isLive&&e&&e.dataset.eventTrackingFb&&e.addEventListener("click",function(i){window.fbq&&window.fbq("track",`${e.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-ipdjskrq0mj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ipdjskrq0mj', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-i92ymbor7x').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-i92ymbor7x', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-23xa8rswglm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-23xa8rswglm', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hkkffgscjx').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hkkffgscjx', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-k2jnryc6cpn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-k2jnryc6cpn', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-b7ih65p7ztl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-b7ih65p7ztl', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zi7e7oh5i5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zi7e7oh5i5', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hj3b9wkl19r').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hj3b9wkl19r', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-neamxnz9iij').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-neamxnz9iij', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9ug0a3xo2ts').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9ug0a3xo2ts', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-uyng4u1vh8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-uyng4u1vh8', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9d7lqm2ym5s').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9d7lqm2ym5s', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-46ch1tug146').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-46ch1tug146', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-s6lr1jey8hn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-s6lr1jey8hn', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7nu3bx4dzsd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7nu3bx4dzsd', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-v7vgruq7lrl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-v7vgruq7lrl', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qc11moig9m9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qc11moig9m9', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kercpsltmx').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kercpsltmx', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kd0pcugulg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kd0pcugulg', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yz2x4vosz7h').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yz2x4vosz7h', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dcr64sykw39').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dcr64sykw39', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kirc7dtxnbs').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kirc7dtxnbs', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cy17ugotjpr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cy17ugotjpr', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nf69jnp9pyd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nf69jnp9pyd', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-x6ozwz1pa5l').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-x6ozwz1pa5l', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-58mpjppojvi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-58mpjppojvi', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mx4oan3qbg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mx4oan3qbg', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3kl2ci9qzat').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3kl2ci9qzat', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4jw9xj7nkje').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4jw9xj7nkje', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6ed3aaitegv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6ed3aaitegv', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jgwdlm3b9c').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jgwdlm3b9c', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-upb6m91bc6h').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-upb6m91bc6h', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-z8kkpmvoq4f').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-z8kkpmvoq4f', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-u1b7vt8gl87').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-u1b7vt8gl87', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ghlpi89l3ff').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ghlpi89l3ff', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-od6j9e9ir6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-od6j9e9ir6', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-r2bcvrznbjq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-r2bcvrznbjq', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hthfss4a5q').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hthfss4a5q', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vldimmui4k').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vldimmui4k', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-m8lj3fp7p8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-m8lj3fp7p8', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-20qut3erwy1').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-20qut3erwy1', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xkp0hdmxvt').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xkp0hdmxvt', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-huajd0vm1hf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-huajd0vm1hf', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kk3wkirizz8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kk3wkirizz8', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-k0qx1vngcz').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-k0qx1vngcz', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2hujqw2bz52').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2hujqw2bz52', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zw67hi5kaj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zw67hi5kaj', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-r0n3jrv7wee').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-r0n3jrv7wee', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-941qzrcsrwc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-941qzrcsrwc', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-w5udpsianle').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-w5udpsianle', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jasp691ywl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jasp691ywl', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-t2yegrzw429').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-t2yegrzw429', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-o9660g7li3q').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-o9660g7li3q', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-b6t9ssyh047').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-b6t9ssyh047', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dbemecrrp4r').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dbemecrrp4r', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ovwtn28cqd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ovwtn28cqd', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3zg7s8jvemd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3zg7s8jvemd', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-o7dvglm42a').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-o7dvglm42a', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ogjym3aa7oo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ogjym3aa7oo', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-klmew6ebgj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-klmew6ebgj', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-08daemmluwq6"]=  window.__ectimmers["ecom-08daemmluwq6"] || {};
const t=function(r){if(window.EComModal)return r();if(window.EComposer&&typeof window.EComposer.loadVendor=="function"){window.EComposer.loadVendor("modal_js").then(function(){window.EComModal&&r()});return}let a=0;const l= window.__ectimmers["ecom-08daemmluwq6"]["6fo4cggex"] = setInterval(function(){window.EComModal?(clearInterval(l),r()):++a>=300&&clearInterval(l)},50)};if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&this.$el){var e=this.$el.querySelector("[ecom-modal]"),i=this.id;t(function(){new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+i]})})}let s=this.$el;if(!s)return;function o(r){const a=r.getBoundingClientRect();return a.top>=0&&a.left>=0&&a.bottom-r.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&a.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let r=s.querySelector(".ecom-element.ecom-base-image"),a=s.closest(".core__row--columns");r&&(o(r)?(r.classList.add("image-highlight"),a.setAttribute("style","z-index: unset")):(r.classList.remove("image-highlight"),a.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-08daemmluwq6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-08daemmluwq6', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xejp8fvre5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xejp8fvre5', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tbr3f5vr0ea').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tbr3f5vr0ea', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ap2ajzaqti').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ap2ajzaqti', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xr9ffwpgtz').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xr9ffwpgtz', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-v5kt1h5zyag').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-v5kt1h5zyag', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jmgqy9418j').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jmgqy9418j', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-49z15d9ekbs').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-49z15d9ekbs', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-l64j24kbip').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-l64j24kbip', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0rotil49xpdk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0rotil49xpdk', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-k5l5rs7qvd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-k5l5rs7qvd', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-55uvfna7w4s').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-55uvfna7w4s', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-y29wf61zsw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-y29wf61zsw', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7we8c7dpttd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7we8c7dpttd', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-w20x91z3jun').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-w20x91z3jun', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-s9aehxsxris').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-s9aehxsxris', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-f8s8q5lzzai').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-f8s8q5lzzai', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8hsgkvrz4g7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8hsgkvrz4g7', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7e10369uo0v').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7e10369uo0v', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mwv2bkhonxe').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mwv2bkhonxe', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wllq2h3h4hj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wllq2h3h4hj', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wgg5z0xo9ga').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wgg5z0xo9ga', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-r63xefkhqh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-r63xefkhqh', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qx7wyo1ymi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qx7wyo1ymi', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xs5gs3xyy4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xs5gs3xyy4', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-csg534426y5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-csg534426y5', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vnxkfd3ty5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vnxkfd3ty5', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-sqg0qtzdoe').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-sqg0qtzdoe', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rrc3kr88hun').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rrc3kr88hun', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yxprt9boe2').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yxprt9boe2', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-y5v7k93ogde').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-y5v7k93ogde', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ryvwmorswpj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ryvwmorswpj', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-goh4s0c0cj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-goh4s0c0cj', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2eoic7vn0qv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2eoic7vn0qv', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7d8gc989q19').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7d8gc989q19', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7crjehqiwy').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7crjehqiwy', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2cppqizrdx6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2cppqizrdx6', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4m5i2313tmf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4m5i2313tmf', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wiac6q1zyi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wiac6q1zyi', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-b7qpf0vum5n').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-b7qpf0vum5n', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8y9he7cbwfw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8y9he7cbwfw', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-o7rm3jfv1yk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-o7rm3jfv1yk', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4523wn4y785').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4523wn4y785', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7fyp849nqi3').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7fyp849nqi3', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8k6w6janyv4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8k6w6janyv4', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mgysp0yi63a').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mgysp0yi63a', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qmq3y12qt7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qmq3y12qt7', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9zlt9ox7ckj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9zlt9ox7ckj', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-61e84ir34n').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-61e84ir34n', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-iggv1423c8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-iggv1423c8', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1xorebq3arv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1xorebq3arv', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rw7j4sl2g5o').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rw7j4sl2g5o', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8v0ik06pic').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8v0ik06pic', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3eox1unp1ma').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3eox1unp1ma', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4g9ryhv8l8v').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4g9ryhv8l8v', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-s1qkiu6tvpi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-s1qkiu6tvpi', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rda89aqstep').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rda89aqstep', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zrj1bf8ujgk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zrj1bf8ujgk', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-21lleeepzy2').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-21lleeepzy2', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vnkbnfm1sag').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vnkbnfm1sag', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}